import React, { useState, useEffect } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";

const PublicationDeanEdit = () => {
  const { id } = useParams();  // Get the id from URL params
  const history = useHistory();
  const [publication, setPublication] = useState(null);  // Initialize publication state

  const [fields, setFields] = useState({
    publication: "",
    doi: "",
    title: "",
    journal: "",
    contribution: "",
    reach: "",
    editionno: "",
    volnum: "",
    isbn: "",
    issn: "",
    pfrom: "",
    pto: "",
    indexing: "",
    issuenum: "",
    impactfactor: "",
    publicationDate: "",
    qualityIndex: "q1",  // Default to "q1"
    claimedBy: "",
    pdf: "",
    status: "0",  // Default to "Unverified"
    collegeCoauthors: [],
    otherCoauthors: [],
  });

  // Fetch the publication data
  useEffect(() => {
    if (id) {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/api/publications/${id}`)
        .then(response => response.json())
        .then(data => {
          setPublication(data);
          setFields({
            publication: data.publication || "",
            doi: data.doi || "",
            title: data.title || "",
            journal: data.journal || "",
            contribution: data.contribution || "",
            reach: data.reach || "",
            editionno: data.editionno || "",
            volnum: data.volnum || "",
            isbn: data.isbn || "",
            issn: data.issn || "",
            pfrom: data.pfrom || "",
            pto: data.pto || "",
            indexing: data.indexing || "",
            issuenum: data.issuenum || "",
            impactfactor: data.impactfactor || "",
            publicationDate: data.publicationDate || "",
            qualityIndex: data.qualityIndex || "q1",
            claimedBy: data.claimedBy || "",
            pdf: data.pdf || "",
            status: data.status || "0",
            collegeCoauthors: data.collegeCoauthors || [],
            otherCoauthors: data.otherCoauthors || [],
          });
        })
        .catch(error => console.error("Error fetching publication:", error));
    }
  }, [id]);

  // Handle status change
  const handleStatusChange = (event) => {
    const { value } = event.target;
    setFields({
      ...fields,
      status: value,
    });
  };

  // Handle quality index change
  const handleQualityIndexChange = (event) => {
    setFields({ ...fields, qualityIndex: event.target.value });
  };

  // Handle form submit
  const handleOnSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/publications/dean/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(fields),
      });
      history.push("/deanview"); // Navigate back to the publications page
    } catch (error) {
     console("Error updating publication:", error);
    }
  };

  if (!publication) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mt-4">
      <h2 className="text-center">Edit Publication</h2>
      <form onSubmit={handleOnSubmit}>
        <div className="row mb-3">
          {/* Publication Type */}
          <div className="form-group col-md-4">
            <label htmlFor="publication" className="form-label">
              Publication Type
            </label>
            <input
              type="text"
              id="publication"
              className="form-control"
              name="publication"
              value={fields.publication}
              readOnly
            />
          </div>

          {/* DOI */}
          <div className="form-group col-md-8">
            <label htmlFor="doi" className="form-label">
              DOI/URL
            </label>
            <input
              type="text"
              id="doi"
              className="form-control"
              placeholder="Enter DOI"
              name="doi"
              value={fields.doi}
              onChange={(e) => setFields({ ...fields, doi: e.target.value })}
            />
          </div>

          {/* Title */}
          <div className="form-group col-md-12">
            <label htmlFor="title" className="form-label">
              Title
            </label>
            <input
              type="text"
              id="title"
              className="form-control"
              placeholder="Enter title"
              name="title"
              value={fields.title}
              onChange={(e) => setFields({ ...fields, title: e.target.value })}
            />
          </div>

          {/* Journal Name */}
          <div className="form-group col-md-12">
            <label htmlFor="journal" className="form-label">
              Journal Name
            </label>
            <input
              type="text"
              id="journal"
              className="form-control"
              placeholder="Enter Journal Name"
              name="journal"
              value={fields.journal}
              onChange={(e) => setFields({ ...fields, journal: e.target.value })}
            />
          </div>

          {/* Contribution */}
          <div className="form-group col-md-5">
            <label htmlFor="contribution" className="form-label">
              Contribution
            </label>
            <input
              type="text"
              id="contribution"
              className="form-control"
              placeholder="Enter Contribution"
              name="contribution"
              value={fields.contribution}
              onChange={(e) => setFields({ ...fields, contribution: e.target.value })}
            />
          </div>

          {/* Reach */}
          <div className="form-group col-md-4">
            <label htmlFor="reach" className="form-label">
              Reach
            </label>
            <input
              type="text"
              id="reach"
              className="form-control"
              placeholder="Enter Reach"
              name="reach"
              value={fields.reach}
              onChange={(e) => setFields({ ...fields, reach: e.target.value })}
            />
          </div>

          {/* Indexing */}
          <div className="form-group col-md-3">
            <label htmlFor="indexing" className="form-label">
              Indexing
            </label>
            <input
              type="text"
              id="indexing"
              className="form-control"
              placeholder="Enter Indexing"
              name="indexing"
              value={fields.indexing}
              onChange={(e) => setFields({ ...fields, indexing: e.target.value })}
            />
          </div>

          {/* Status */}
          <div className="form-group col-md-3">
            <label htmlFor="status" className="form-label">
              Status
            </label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              

              <input
                type="radio"
                id="status1"
                name="status"
                value="3"
                checked={fields.status === "3"}
                onChange={handleStatusChange}
                disabled={fields.status === "3"}
               
              />
              <label htmlFor="status1" style={{ marginRight: '10px' }}>Approved Level2</label>

              
            </div>
          </div>

          {/* Quality Index */}
          <div className="form-group col-md-4">
            <label htmlFor="qualityIndex" className="form-label">
              Quality Index
            </label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="radio"
                id="q1"
                name="qualityIndex"
                value="q1"
                checked={fields.qualityIndex === "q1"}
                onChange={handleQualityIndexChange}
               
              />
              <label htmlFor="q1" style={{ marginRight: '10px' }}>Q1</label>

              <input
                type="radio"
                id="q2"
                name="qualityIndex"
                value="q2"
                checked={fields.qualityIndex === "q2"}
                onChange={handleQualityIndexChange}
               
              />
              <label htmlFor="q2" style={{ marginRight: '10px' }}>Q2</label>

              <input
                type="radio"
                id="q3"
                name="qualityIndex"
                value="q3"
                checked={fields.qualityIndex === "q3"}
                onChange={handleQualityIndexChange}
               
              />
              <label htmlFor="q4" style={{ marginRight: '10px' }}>Q3</label>
              <input
                type="radio"
                id="q4"
                name="qualityIndex"
                value="q4"
                checked={fields.qualityIndex === "q4"}
                onChange={handleQualityIndexChange}
               
              />
              <label htmlFor="q3" style={{ marginRight: '10px' }}>Q4</label>
            </div>
          </div>

          {/* Submit Button */}
          <div className="col-md-12 text-center mt-4">
            <button type="submit" className="btn btn-primary">
              Update Publication
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default PublicationDeanEdit;
